import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { getDirectionsUrl } from '@grandvisionhq/utils';
import { useAddToCalendarDlEventDispatcher } from '../../data-layer/hooks/use-add-to-calendar-dl-event-dispatcher.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import { usePageData } from '../../pages/BookAppointment/context/PageDataContext.js';
import AppointmentConfirmation from './AppointmentConfirmation.js';
import useVirtualAppointment from '../../pages/BookAppointment/hooks/use-virtual-appointment.js';
import useStoreOfferByCode from '../../hooks/api/use-store-offer-by-code.js';
import { clearStoredAffiliateId } from '../../utils/affiliate-id-storage.js';

const emptyArray = [];
const AppointmentConfirmationContainer = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const [, { store , type , timeSlot , appointment: baseAppointment  }] = useAppointmentContext();
    const { googleMapsApiKey , storesUrl , opco , appointmentTypes , offerFallbackImageUrl  } = usePageData();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [getStoreOfferByCode, storeOfferByCode] = useStoreOfferByCode({
        code: 0
    });
    var ref;
    const labels = React.useMemo(()=>{
        var ref1;
        return {
            heading: getFormattedLabel(`appointments.component.appointmentConfirmation.${(baseAppointment === null || baseAppointment === void 0 ? void 0 : baseAppointment.isReservation) ? 'reservationHeading' : 'heading'}`, {
                labelData: {
                    name: (ref = baseAppointment === null || baseAppointment === void 0 ? void 0 : (ref1 = baseAppointment.invitee) === null || ref1 === void 0 ? void 0 : ref1.firstName) !== null && ref !== void 0 ? ref : ''
                }
            }),
            subHeading: getLabel(`appointments.component.appointmentConfirmation.${(baseAppointment === null || baseAppointment === void 0 ? void 0 : baseAppointment.isReservation) ? 'reservationSubheading' : 'subHeading'}`),
            notification: getLabel(`appointments.component.appointmentConfirmation.${(baseAppointment === null || baseAppointment === void 0 ? void 0 : baseAppointment.preferredChannelOfCommunication) === Types.AppointmentCommunicationChannel.EMAIL ? 'emailNotification' : 'smsNotification'}`),
            addToCalendar: getLabel('appointments.component.appointmentConfirmation.addToCalendar'),
            appointment: getLabel('appointments.component.appointmentConfirmation.appointment'),
            where: getLabel('appointments.component.appointmentConfirmation.where'),
            who: getLabel('appointments.component.appointmentConfirmation.who'),
            getDirections: getLabel('appointments.component.appointmentConfirmation.getDirections'),
            cantMakeIt: getLabel('appointments.component.appointmentConfirmation.cantMakeIt'),
            cancelOrReschedule: getFormattedLabel('appointments.component.appointmentConfirmation.cancelOrReschedule', {
                parseHTML: true,
                parseLink: true
            }),
            exploreProducts: getLabel('appointments.component.appointmentConfirmation.exploreProducts')
        };
    }, [
        baseAppointment,
        getLabel,
        getFormattedLabel
    ]);
    const appointment = React.useMemo(()=>baseAppointment && type ? swcHelpers.objectSpread({}, baseAppointment, {
            appointmentType: type
        }) : null
    , [
        baseAppointment,
        type
    ]);
    const directionsUrl = store ? getDirectionsUrl({
        streetName: store.streetName,
        town: store.town,
        opco
    }) : undefined;
    const appointmentConfirmationContent = React.useMemo(()=>{
        const foundContent = appointmentTypes === null || appointmentTypes === void 0 ? void 0 : appointmentTypes.find((content)=>{
            return content.typeId === (type === null || type === void 0 ? void 0 : type.id);
        });
        return foundContent === null || foundContent === void 0 ? void 0 : foundContent.appointmentConfirmationContent;
    }, [
        appointmentTypes,
        type
    ]);
    React.useEffect(()=>{
        if (!store) {
            return;
        }
        getStoreOfferByCode({
            variables: {
                code: Number(store.code)
            }
        });
    }, [
        getStoreOfferByCode,
        appointment,
        store
    ]);
    const { pushAddToCalendarDlEvent  } = useAddToCalendarDlEventDispatcher({
        appointmentCondition: 'new',
        type,
        store,
        isVirtualAppointment: isVirtualAppointmentType(type),
        timeSlot
    });
    React.useEffect(()=>{
        clearStoredAffiliateId();
    }, []);
    if (!store || !type || !timeSlot || !appointment) {
        return null;
    }
    var _data;
    return /*#__PURE__*/ React.createElement(AppointmentConfirmation, {
        labels: labels,
        store: store,
        offers: (_data = storeOfferByCode.data) !== null && _data !== void 0 ? _data : emptyArray,
        type: type,
        timeSlot: timeSlot,
        appointment: appointment,
        isVirtualAppointmentType: isVirtualAppointmentType(type),
        googleMapsApiKey: !isVirtualAppointmentType(type) ? googleMapsApiKey : undefined,
        storesUrl: !isVirtualAppointmentType(type) ? storesUrl : undefined,
        directionsUrl: directionsUrl,
        appointmentConfirmationContent: appointmentConfirmationContent,
        offerFallbackImageUrl: offerFallbackImageUrl,
        onICSButtonClick: pushAddToCalendarDlEvent
    });
};
var AppointmentConfirmationContainer$1 = AppointmentConfirmationContainer;

export { AppointmentConfirmationContainer$1 as default };
//# sourceMappingURL=AppointmentConfirmationContainer.js.map
